"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var classes = function classes(hidden) {
  return (0, _classnames["default"])({
    'show-hide': true,
    hidden: hidden
  });
};
var ShowHide = function ShowHide(_ref) {
  var children = _ref.children,
    hide = _ref.hide;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes(hide)
  }, children);
};
ShowHide.propTypes = {
  /** Set to true to hide children, defaults to false */
  hide: _propTypes["default"].bool,
  /** Content to conditionally show or hide */
  children: _propTypes["default"].any.isRequired
};
ShowHide.defaultProps = {
  hide: false
};
var _default = exports["default"] = ShowHide;